import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const ConfirmationStepSkeleton = () => (
  <Skeleton
    className={s.card}
    borderRadius={20}
  />
)
